import React from 'react';

import Color from '@/tool/color';

interface ISizeProps {
  color?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

interface ColorProps {
  color?: string;
  onClick?: () => void;
}

const UserVip = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '8px',
      height: props.height ? `${props.height}px` : '8px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-iconheaderuservipFFFFFF1" />
  </svg>
);

const UserVip2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '8px',
      height: props.height ? `${props.height}px` : '8px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-iconheaderuservip" />
  </svg>
);

const UserIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '8px',
      height: props.height ? `${props.height}px` : '8px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-iconheaderuserFFFFFF1" />
  </svg>
);

const OmniIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '210px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-logohromnisightcn" />
  </svg>
);

const WtwIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '250px',
      height: props.height ? `${props.height}px` : '18px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-wtwl" />
  </svg>
);

const CoIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '48px',
      height: props.height ? `${props.height}px` : '18px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-iconco" />
  </svg>
);

const CloseIcon = (props: ISizeProps) => (
  <svg
    className="icon"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.primary,
    }}>
    <use xlinkHref="#icon-zhongxinxuanze" />
  </svg>
);

const SuccessFillIcon = (props: ISizeProps) => (
  <svg
    className="icon"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.primary,
    }}>
    <use xlinkHref="#icon-success-fill" />
  </svg>
);

const GoCircleIcon = (props: ISizeProps) => (
  <svg
    className="icon"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.primaryColor(1),
    }}>
    <use xlinkHref="#icon-icongoF" />
    icon-icongoFicon-icongoF
  </svg>
);

const PoweredBy = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-poweredby" />
  </svg>
);

const WeixinIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-quickbarcomment" />
  </svg>
);

const PhoneIcon3 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-quickbarphone" />
  </svg>
);

const Star1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-xinchoudiyi" />
  </svg>
);

const VipFill = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-vip-fill" />
  </svg>
);

const SearchIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-search1" />
  </svg>
);

const IconX1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-duibiaoqiyezhaopindongtai" />
  </svg>
);

const IconX2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-renlihexinzhibiao" />
  </svg>
);

const IconX3 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-cq-duiditzhuzhuangtu" />
  </svg>
);

const IconX4 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhiweixinchou" />
  </svg>
);

const IconX5 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-dingzhixinchoubaogao" />
  </svg>
);

const IconX11 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-niandutiaoxincelve" />
  </svg>
);

const IconX12 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-gongsixinchouzhenduan" />
  </svg>
);

const IconX13 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-xinchoutixisheji" />
  </svg>
);

const IconX21 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-xinwenzhongxin" />
  </svg>
);

const IconX22 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-qiyekehu" />
  </svg>
);

const IconX23 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-chengweihezuohuoban" />
  </svg>
);

const IconX24 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-guanyuwomen" />
  </svg>
);

const UpFullIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-play_fill_up" />
  </svg>
);

const GoRight = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-a-juxing2" />
  </svg>
);

const IconHot = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-redu" />
  </svg>
);

const IconY1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyerenxiao-landi" />
  </svg>
);
const IconY2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-duibiaoqiyezhaopindongtai-landi" />
  </svg>
);
const IconY3 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-renlihexinzhibiao-landi" />
  </svg>
);
const IconY4 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-xinchoubaogao--landi" />
  </svg>
);
const IconY5 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-dingzhixinchoubaogao-landi" />
  </svg>
);

const IconX88 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyerenxiao-baidi" />
  </svg>
);

const Know1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-feeds" />
  </svg>
);

const Know2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-image-text" />
  </svg>
);
const Know3 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-fenzhi" />
  </svg>
);
const Know4 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-RFQ-logo" />
  </svg>
);
const Know5 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-office-supplies" />
  </svg>
);

const Icongo1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.whiteColor(0.3),
    }}>
    <use xlinkHref="#icon-go" />
  </svg>
);

const VPlay = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '30px',
      height: props.height ? `${props.height}px` : '30px',
      fill: props.color || Color.whiteColor(1),
    }}>
    <use xlinkHref="#icon-bofang" />
  </svg>
);

const NPlay = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '18px',
      height: props.height ? `${props.height}px` : '18px',
      fill: props.color || Color.primaryColor(1),
    }}>
    <use xlinkHref="#icon-playon" />
  </svg>
);

const CloseIcon20 = (props: ISizeProps) => (
  <svg
    className="icon"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.primary,
    }}>
    <use xlinkHref="#icon-zhongxinxuanze" />
  </svg>
);

const ContactUs = (props: ISizeProps) => (
  <svg
    className="icon"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.primary,
    }}>
    <use xlinkHref="#icon-lianxiwomen" />
  </svg>
);

const InsightCity = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-chengshibuju" />
  </svg>
);

const InsightCityGrey = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-chengshibuju-shouqi" />
  </svg>
);

const InsightRecruit = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-zhaopindongxiang" />
  </svg>
);

const InsightRecruitGrey = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-zhaopindongxiang-shouqi" />
  </svg>
);

const InsightTalent = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-rencaixuqiugoucheng" />
  </svg>
);

const InsightTalentGrey = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-rencaixuqiugoucheng-shouqi" />
  </svg>
);

const InsightTrend = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-fazhanqushi" />
  </svg>
);

const InsightTrendGrey = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-fazhanqushi-shouqi" />
  </svg>
);

const DownFullIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-play_fill" />
  </svg>
);

const GoLeftIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-xiangzuo" />
  </svg>
);

const TableIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-tubiao-weixuanzhong" />
  </svg>
);

const ChartIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-biaoge-weixuanzhong" />
  </svg>
);

const TableActiveIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-biaoge-xuanzhong" />
  </svg>
);

const ChartActiveIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-tubiao-xuanzhong" />
  </svg>
);

const BrowseIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-browse" />
  </svg>
);

const EntityHuman = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-roam" />
  </svg>
);

const CircleHuman = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-miaobianren1" />
  </svg>
);

const EntityCaiwu = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-caiwu" />
  </svg>
);

const CircleCaiwu = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-caiwu-miaobian" />
  </svg>
);

const EntityFawu = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-fawu" />
  </svg>
);

const CircleFawu = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-fawu-miaobian" />
  </svg>
);

const EntityIT = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-IT" />
  </svg>
);

const CircleIT = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-IT-miaobian" />
  </svg>
);

const EntityXingzheng = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-hangzheng" />
  </svg>
);

const CircleXingzheng = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-hangzheng-miaobian" />
  </svg>
);

const EffectIcon11 = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-renxiao" />
  </svg>
);

const EffectIcon12 = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-xinchouchengbentouru" />
  </svg>
);

const EffectIcon13 = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-renyuanpeizhi" />
  </svg>
);

const EffectIcon14 = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-zhichixiaoneng" />
  </svg>
);

const EffectIcon11Gray = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-renxiao-hui" />
  </svg>
);

const EffectIcon12Gray = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-xinchouchengbentouru-hui" />
  </svg>
);

const EffectIcon13Gray = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-renyuanpeizhi-hui" />
  </svg>
);

const EffectIcon14Gray = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-zhichixiaoneng-hui" />
  </svg>
);

const EffectIcon55 = (props: ISizeProps) => (
  <svg
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '12px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.fff,
    }}>
    <use xlinkHref="#icon-a-renxiao-nav" />
  </svg>
);

const DownloadIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-download" />
  </svg>
);

const AddIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-x" />
  </svg>
);

const PromptIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.ccc,
    }}>
    <use xlinkHref="#icon-prompt-fill" />
  </svg>
);

const RankingLIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '27px',
      height: props.height ? `${props.height}px` : '28px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-rankingl" />
  </svg>
);

const RankingRIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '27px',
      height: props.height ? `${props.height}px` : '28px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-rankingr" />
  </svg>
);

const ChartIconInActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-tubiao-weixuanzhong" />
  </svg>
);

const TableIconInActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-biaoge-weixuanzhong" />
  </svg>
);

const TableIconActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-biaoge-xuanzhong" />
  </svg>
);

const ChartIconActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-tubiao-xuanzhong" />
  </svg>
);

const LightIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-dengpao" />
  </svg>
);

const GongsishuIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '14px',
      height: '14px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-gongsishu" />
  </svg>
);

const YangbenshuIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '14px',
      height: '14px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yangbenshu" />
  </svg>
);

const GongsishuIcon2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-gongsishu" />
  </svg>
);

const YangbenshuIcon2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yangbenshu" />
  </svg>
);

const ZhiWeiIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '20px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhiweishuliang" />
  </svg>
);

const ZhiNengIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '20px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhinengshuliang" />
  </svg>
);

const ArrowDown = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-arrow-down" />
  </svg>
);

const OutFlow = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '20px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-arrowly" />
  </svg>
);

const InFlow = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '20px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-arrowr" />
  </svg>
);

const Icon101InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyegailan-weixuanzhong" />
  </svg>
);

const Icon101Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyegailan-xuanzhong" />
  </svg>
);

const Icon102InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyeyanbao-weixuanzhong" />
  </svg>
);

const Icon102Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyeyanbao-xuanzhong" />
  </svg>
);

const Icon103InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhangxinshuai-weixuanzhong" />
  </svg>
);

const Icon103Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhangxinshuai-xuanzhong" />
  </svg>
);
const Icon104InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-lizhishuai-weixuanzhong" />
  </svg>
);
const Icon104Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-lizhishuai-xuanzhong" />
  </svg>
);
const Icon105InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yingjieshengqixin-weixuanzhong" />
  </svg>
);
const Icon105Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yingjieshengqixin-xuanzhong" />
  </svg>
);
const Icon106InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-chengshixinchouchayixishu-weixuanzhong" />
  </svg>
);
const Icon106Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-chengshixinchouchayixishu-xuanzhong" />
  </svg>
);
const Icon107InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyezhaopinqushi-weixuanzhong" />
  </svg>
);
const Icon107Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-hangyezhaopinqushi-weixuanzhongbeifen" />
  </svg>
);
const Icon108InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-gongsizhaopindongtai-weixuanzhong" />
  </svg>
);
const Icon108Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-gongsizhaopindongtai-weixuanzhongbeifen" />
  </svg>
);
const Icon109InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-chengshizhaopinqushi-weixuanzhong" />
  </svg>
);
const Icon109Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-chengshizhaopinqushi-weixuanzhongbeifen" />
  </svg>
);
const Icon110InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhinengzhaopinqushi-weixuanzhong" />
  </svg>
);
const Icon110Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-zhinengzhaopinqushi-weixuanzhongbeifen" />
  </svg>
);
const Icon111InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-remenxifenzhineng-weixuanzhong" />
  </svg>
);
const Icon111Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-remenxifenzhineng-weixuanzhongbeifen" />
  </svg>
);
const Icon112InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-qiyeyusuan-weixuanzhong" />
  </svg>
);
const Icon112Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-qiyeyusuan-weixuanzhongbeifen" />
  </svg>
);
const Icon113InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yuangongxihao-weixuanzhong" />
  </svg>
);
const Icon113Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yuangongxihao-weixuanzhongbeifen" />
  </svg>
);
const Icon114InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-rencailiudong-weixuanzhong" />
  </svg>
);
const Icon114Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-rencailiudong-weixuanzhongbeifen" />
  </svg>
);
const Icon115InActive = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-rencaihuaxiang-weixuanzhong" />
  </svg>
);
const Icon115Active = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-rencaihuaxiang-weixuanzhongbeifen" />
  </svg>
);

const RencaiIcon2 = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '18px',
      height: '18px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-rencaixuqiu" />
  </svg>
);

const XinchouIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '18px',
      height: '18px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-pingjunxinchou" />
  </svg>
);

const YangbenIcon2 = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '18px',
      height: '18px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-yangbenshujuliang" />
  </svg>
);

const XinzhiLarge = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '140px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-logodashujupingtaifanbai" />
  </svg>
);

const UpIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '8px',
      height: props.height ? `${props.height}px` : '8px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-shangzhang" />
  </svg>
);

const DownIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '8px',
      height: props.height ? `${props.height}px` : '8px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-xiadie" />
  </svg>
);

const PuseIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '20px',
      height: '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-suspended" />
  </svg>
);

const PdfLogo = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '69px',
      height: '30px',
      fill: props.color || Color.primary,
    }}>
    <use xlinkHref="#icon-a-logodaiwangzhi" />
  </svg>
);

const ConfigIcon = (props: ColorProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: '16px',
      height: '16px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-jiekoupeizhi" />
  </svg>
);

const EditIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.c55,
    }}>
    <use xlinkHref="#icon-bianji" />
  </svg>
);

const HouseIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-zhengfu" />
  </svg>
);

const CloseFillIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-a-closebanner" />
  </svg>
);

const DtaileIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-a-gocircle2" />
  </svg>
);

const IconA01 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-suozaihangye" />
  </svg>
);

const IconA02 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-suozaichengshi" />
  </svg>
);

const IconA03 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-qiyeguimo" />
  </svg>
);

const IconA04 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-qiyeleixing" />
  </svg>
);

const NextRightIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '17px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-xiangyou" />
  </svg>
);

const Icon21 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '17px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-chengshi" />
  </svg>
);

const Icon22 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '17px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-hangye" />
  </svg>
);

const Icon23 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '17px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-jiaose" />
  </svg>
);

const EditFill = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '17px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-gongsimingchengbianji" />
  </svg>
);

const UpChangeIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '9px',
      fill: props.color || Color.error,
    }}>
    <use xlinkHref="#icon-shangzhang1" />
  </svg>
);

const DownChangeIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '9px',
      fill: props.color || Color.success,
    }}>
    <use xlinkHref="#icon-xiadie1" />
  </svg>
);

const RepoetIcon1 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.success,
    }}>
    <use xlinkHref="#icon-xuangang" />
  </svg>
);

const RepoetIcon2 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.success,
    }}>
    <use xlinkHref="#icon-dinggang" />
  </svg>
);

const RepoetIcon3 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.success,
    }}>
    <use xlinkHref="#icon-pinggang" />
  </svg>
);

const RepoetIcon4 = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '14px',
      height: props.height ? `${props.height}px` : '14px',
      fill: props.color || Color.success,
    }}>
    <use xlinkHref="#icon-tiaoxin" />
  </svg>
);

const HideEyeIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-yincangmokuai" />
  </svg>
);

const ShowEyeIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '10px',
      height: props.height ? `${props.height}px` : '12px',
      fill: props.color || Color.white,
    }}>
    <use xlinkHref="#icon-xianshimokuai" />
  </svg>
);

const DragIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '40px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-tuodong" />
  </svg>
);

const CollectionIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-collection" />
  </svg>
);

const CollectionFillIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-collection_fill" />
  </svg>
);

const MessageIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-shujuzhongxin-gonggao" />
  </svg>
);

const DashboardIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-shujuzhongxin" />
  </svg>
);

const HotIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-hot-fill" />
  </svg>
);

const GuwenIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.cf,
    }}>
    <use xlinkHref="#icon-guwen" />
  </svg>
);

const RadioCheck = (props: ISizeProps) => (
  <svg className="svg-xinzhi-logo" aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-success-fill" />
  </svg>
);

const UnRadioCheck = (props: ISizeProps) => (
  <svg className="svg-xinzhi-logo" aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '16px',
      height: props.height ? `${props.height}px` : '16px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-success" />
  </svg>
);

const CloseFullIcon = (props: ISizeProps) => (
  <svg className="svg-xinzhi-logo" aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '18px',
      height: props.height ? `${props.height}px` : '18px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-a-closebanner" />
  </svg>
);

const QuestionIcon = (props: ISizeProps) => (
  <svg
    className="svg-xinzhi-logo"
    aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '24px',
      height: props.height ? `${props.height}px` : '24px',
      fill: props.color || Color.primaryColor(0.5),
    }}>
    <use xlinkHref="#icon-xingzhuang" />
  </svg>
);

const AIFill = (props: ISizeProps) => (
  <svg className="svg-xinzhi-logo" aria-hidden="true"
    style={{
      width: props.width ? `${props.width}px` : '20px',
      height: props.height ? `${props.height}px` : '20px',
      fill: props.color || Color.three,
    }}>
    <use xlinkHref="#icon-ai-fill" />
  </svg>
);


export {
  QuestionIcon,
  CloseFullIcon,
  RadioCheck,
  UnRadioCheck,
  DragIcon,
  ShowEyeIcon,
  HideEyeIcon,
  RepoetIcon1,
  RepoetIcon2,
  RepoetIcon3,
  RepoetIcon4,
  UpChangeIcon,
  DownChangeIcon,
  UserVip,
  UserVip2,
  UserIcon,
  OmniIcon,
  WtwIcon,
  CoIcon,
  CloseIcon,
  BrowseIcon,
  SuccessFillIcon,
  GoCircleIcon,
  PoweredBy,
  WeixinIcon,
  PhoneIcon3,
  Icongo1,
  Star1,
  VipFill,
  SearchIcon,
  IconX1,
  IconX2,
  IconX3,
  IconX4,
  IconX5,
  IconHot,
  IconX11,
  IconX12,
  IconX13,
  IconX21,
  IconX22,
  IconX23,
  IconX24,
  UpFullIcon,
  GoRight,
  IconY1,
  IconY2,
  IconY3,
  IconY4,
  IconY5,
  IconX88,
  Know1,
  Know2,
  Know3,
  Know4,
  Know5,
  VPlay,
  CloseIcon20,
  ContactUs,
  InsightRecruit,
  InsightRecruitGrey,
  TableActiveIcon,
  InsightTalent,
  InsightTalentGrey,
  InsightCity,
  InsightCityGrey,
  ChartActiveIcon,
  InsightTrend,
  InsightTrendGrey,
  DownFullIcon,
  GoLeftIcon,
  ChartIcon,
  TableIcon,
  EntityHuman,
  CircleHuman,
  EntityFawu,
  CircleFawu,
  EntityIT,
  CircleIT,
  EntityCaiwu,
  CircleCaiwu,
  EntityXingzheng,
  CircleXingzheng,
  DownloadIcon,
  EffectIcon11,
  EffectIcon12,
  EffectIcon13,
  EffectIcon14,
  EffectIcon55,
  EffectIcon11Gray,
  EffectIcon12Gray,
  EffectIcon13Gray,
  EffectIcon14Gray,
  AddIcon,
  PromptIcon,
  RankingLIcon,
  RankingRIcon,
  ChartIconInActive,
  ChartIconActive,
  TableIconInActive,
  TableIconActive,
  LightIcon,
  GongsishuIcon,
  YangbenshuIcon,
  ZhiWeiIcon,
  ZhiNengIcon,
  ArrowDown,
  OutFlow,
  InFlow,
  NPlay,
  Icon101InActive,
  Icon101Active,
  Icon102InActive,
  Icon102Active,
  Icon103InActive,
  Icon103Active,
  Icon104InActive,
  Icon104Active,
  Icon105InActive,
  Icon105Active,
  Icon106InActive,
  Icon106Active,
  Icon107InActive,
  Icon107Active,
  Icon108InActive,
  Icon108Active,
  Icon109InActive,
  Icon109Active,
  Icon110InActive,
  Icon110Active,
  Icon111InActive,
  Icon111Active,
  Icon112InActive,
  Icon112Active,
  Icon113InActive,
  Icon113Active,
  Icon114InActive,
  Icon114Active,
  Icon115InActive,
  Icon115Active,
  RencaiIcon2,
  XinchouIcon,
  YangbenIcon2,
  XinzhiLarge,
  UpIcon,
  DownIcon,
  PuseIcon,
  PdfLogo,
  GongsishuIcon2,
  YangbenshuIcon2,
  ConfigIcon,
  EditIcon,
  HouseIcon,
  CloseFillIcon,
  DtaileIcon,
  IconA01,
  IconA02,
  IconA03,
  IconA04,
  NextRightIcon,
  Icon21,
  Icon22,
  Icon23,
  EditFill,
  CollectionIcon,
  CollectionFillIcon,
  DashboardIcon,
  MessageIcon,
  HotIcon,
  GuwenIcon,
  AIFill,
};
